import React from "react";
import { useNavigate } from "react-router-dom";
import { FaPhone, FaSignInAlt, FaBars, FaTimes, FaEnvelope, FaMapMarkerAlt, FaClock } from "react-icons/fa";
import logo from "../assets/logoelite.jpeg";

const Contact = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = React.useState(false);
  const [form, setForm] = React.useState({ name: "", email: "", message: "" });

  const handleLoginClick = () => navigate("/login");

  const go = (path) => {
    setMenuOpen(false);
    navigate(path);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // placeholder: replace with real API call
    alert("Thank you! Your message has been received. We'll get back to you soon.");
    setForm({ name: "", email: "", message: "" });
  };

  const css = `
    :root{
      --brand-1:#512da8;
      --brand-2:#7b1fa2;
      --heading:#071127;
      --muted:#475569;
      --accent:#233044;
    }

    .contact-page { font-family: Inter, system-ui, -apple-system, 'Segoe UI', Roboto, Arial; color:var(--accent); min-height:100vh; display:flex; flex-direction:column; -webkit-font-smoothing:antialiased; }
    .header { display:flex; justify-content:space-between; align-items:center; padding:20px 28px; background:#003366; color:#fff; position:sticky; top:0; z-index:90; }
    .logo-container { display:flex; align-items:center; gap:14px; }
    .logo { height:52px; border-radius:6px; object-fit:cover; }
    .logo-text { font-weight:900; font-size:20px; color:#fff; letter-spacing:0.4px; }
    .menu-icon { color:#fff; font-size:20px; cursor:pointer; display:none; background:none; border:none; }
    .nav-links { display:flex; gap:14px; align-items:center; }
    .nav-links.open { display:flex; }
    .nav-btn-link { background:none; border:none; color:#fff; font-weight:700; font-size:15px; cursor:pointer; padding:6px 8px; }
    .header-right { display:flex; align-items:center; gap:12px; }
    .phone-btn { color:#fff; text-decoration:none; display:flex; align-items:center; gap:8px; font-weight:800; font-size:15px; }
    .login-btn { background:linear-gradient(90deg,var(--brand-1),var(--brand-2)); color:#fff; border:none; padding:10px 16px; border-radius:10px; cursor:pointer; font-weight:900; font-size:15px; }

    .contact-hero { background: linear-gradient(135deg, rgba(81,45,168,0.92), rgba(24,118,210,0.86)), url('https://images.unsplash.com/photo-1496307042754-b4aa456c4a2d?auto=format&fit=crop&w=1600&q=60') center/cover no-repeat; color:#fff; padding:84px 20px; text-align:center; }
    .contact-hero h1 { font-size:56px; margin-bottom:14px; font-weight:900; letter-spacing:0.5px; line-height:1.02; color:#ffffff; text-shadow:0 6px 18px rgba(7,17,39,0.18);}
    .contact-hero p { max-width:980px; margin:0 auto; background:rgba(255,255,255,0.06); padding:22px; border-radius:12px; line-height:1.8; font-size:20px; color:rgba(255,255,255,0.95); box-shadow: inset 0 -1px 0 rgba(255,255,255,0.02); }

    /* Enlarged, asymmetric contact-main to make use of empty space and look 'odd' */
    .contact-main {
      max-width:1400px;
      width:100%;
      margin:56px auto;
      padding:0 36px 72px;
      display:grid;
      /* larger left column and a wider right column to use empty space; slightly increased */
      grid-template-columns: 1.8fr 560px;
      gap:52px;
      align-items:start;
      align-content:start;
    }

    .contact-card {
      background:#fff;
      border-radius:14px;
      box-shadow:0 22px 48px rgba(16,24,40,0.09);
      overflow:hidden;
      padding:32px;
      transition:transform .45s ease, box-shadow .45s ease;
    }
    /* slight lift on hover */
    .contact-card:hover { transform: translateY(-8px); box-shadow:0 34px 80px rgba(16,24,40,0.12); }

    /* create an 'odd' stagger effect: left card pushes slightly left, right column stacks with offset */
    .contact-main > .contact-card:first-child { transform: translateX(-16px); }
    .contact-main > div:nth-child(2) { transform: translateY(22px); }

    .contact-info { display:flex; flex-direction:column; gap:20px; }
    .info-row { display:flex; gap:18px; align-items:flex-start; }
    .info-icon { width:64px; height:64px; border-radius:12px; display:flex; align-items:center; justify-content:center; background:linear-gradient(90deg,var(--brand-1),var(--brand-2)); color:#fff; font-size:22px; flex:0 0 64px; box-shadow: 0 10px 30px rgba(81,45,168,0.12); }
    .info-content { display:flex; flex-direction:column; }
    .info-title { font-weight:900; color:var(--heading); margin:0; font-size:22px; }
    .info-sub { color:var(--muted); margin-top:8px; font-size:16px; max-width:980px; }

    .hours { display:flex; gap:14px; flex-wrap:wrap; margin-top:8px; }
    .badge { background:#f7f8fb; color:var(--heading); padding:11px 16px; border-radius:12px; font-weight:900; font-size:16px; box-shadow:0 6px 20px rgba(16,24,40,0.04); }

    .contact-form { display:flex; flex-direction:column; gap:16px; margin-top:18px; }
    .contact-form input, .contact-form textarea {
      width:100%;
      padding:16px 18px;
      border-radius:12px;
      border:1px solid #eef4fb;
      font-size:18px;
      color:var(--heading);
      box-shadow: inset 0 1px 0 rgba(255,255,255,0.6);
      transition: box-shadow .22s ease, transform .15s ease;
    }
    .contact-form input::placeholder, .contact-form textarea::placeholder { color:#9aa6b2; font-weight:600; }
    .contact-form input:focus, .contact-form textarea:focus {
      outline:none;
      box-shadow:0 10px 40px rgba(81,45,168,0.10);
      transform: translateY(-3px);
      border-color: rgba(81,45,168,0.38);
    }
    .contact-form button {
      background:linear-gradient(90deg,var(--brand-1),var(--brand-2));
      color:#fff;
      border:none;
      padding:16px 20px;
      border-radius:14px;
      cursor:pointer;
      font-weight:900;
      font-size:16px;
      margin-top:6px;
      align-self:flex-start;
      box-shadow:0 12px 36px rgba(81,45,168,0.12);
    }

    .map-embed { border-radius:12px; overflow:hidden; height:520px; box-shadow:0 22px 48px rgba(16,24,40,0.09); }

    /* quick-link cards on the right column are larger and offset for asymmetric layout */
    .contact-main > div > .contact-card + .contact-card { padding:22px; }

    /* consistent site footer */
    .site-footer, .footer {
      padding:32px;
      text-align:center;
      color:#6b7280;
      margin-top:auto;
      background:#f7f7f7;
      font-size:15px;
      border-top:1px solid #eef2f7;
    }

    @media (max-width: 1200px) {
      .contact-main { grid-template-columns: 1fr 520px; gap:36px; padding:0 24px 48px; }
      .contact-main > .contact-card:first-child, .contact-main > div:nth-child(2) { transform:none; }
      .map-embed { height:420px; }
    }

    @media (max-width: 980px) {
      .contact-main { grid-template-columns: 1fr; gap:22px; padding:0 18px 40px; }
      .contact-main > .contact-card:first-child, .contact-main > div:nth-child(2) { transform:none; }
      .menu-icon { display:block; }
      .nav-links { display:none; position:absolute; top:72px; right:16px; background:#003366; padding:12px; border-radius:10px; flex-direction:column; gap:8px; }
      .nav-links.open { display:flex; width:240px; }
      .map-embed { height:320px; }
    }

    @media (max-width: 600px) {
      .contact-hero h1 { font-size:32px; }
      .contact-hero p { font-size:15px; padding:12px; }
      .info-title { font-size:18px; }
      .info-sub { font-size:14px; }
      .badge { font-size:14px; padding:8px 12px; }
      .contact-form input, .contact-form textarea { font-size:16px; padding:12px; }
    }
  `;

  return (
    <div className="contact-page">
      <style>{css}</style>

      <header className="header">
        <div className="logo-container">
          <img src={logo} alt="Elite Academy Logo" className="logo" />
          <span className="logo-text">Elite Academy</span>
        </div>

        <button className="menu-icon" aria-label="Toggle menu" onClick={() => setMenuOpen(s => !s)}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>

        <div className={`nav-links ${menuOpen ? "open" : ""}`}>
          <button className="nav-btn-link" onClick={() => go("/")}>HOME</button>
          <button className="nav-btn-link" onClick={() => go("/about")}>ABOUT US</button>
          <button className="nav-btn-link" onClick={() => go("/features")}>FEATURES</button>
          <button className="nav-btn-link" onClick={() => go("/contact")}>CONTACT US</button>
        </div>

        <div className="header-right">
           <button
            className="sample-btn"
            onClick={() => navigate("/sample-copy")}
            aria-label="View sample copies"
            style={{
              marginLeft: 12,
              background: "linear-gradient(90deg,#ff7a18,#af002d)",
              color: "#fff",
              border: "none",
              padding: "8px 14px",
              borderRadius: 8,
              boxShadow: "0 6px 18px rgba(175,0,45,0.18)",
              cursor: "pointer",
              fontWeight: 700,
              letterSpacing: 0.2,
            }}
          >
            Sample Copy
          </button>
          <button className="login-btn" onClick={handleLoginClick}><FaSignInAlt /> Login</button>
        </div>
      </header>

      <section className="contact-hero">
        <h1>Contact Elite Academy</h1>
        <p>Reach out for partnership, school onboarding or support. We respond quickly and are ready to help schools, teachers and parents get started.</p>
      </section>

      <main className="contact-main">
        <div className="contact-card">
          <h2 style={{ marginTop: 0, fontSize: 30, color: "var(--heading)" }}>Get in touch</h2>

          <div className="contact-info">
            <div className="info-row">
              <div className="info-icon"><FaMapMarkerAlt /></div>
              <div className="info-content">
                <div className="info-title">Office</div>
                <div className="info-sub" style={{fontSize: 22}}>Road No.5, KPHB Colony, Kukatpally, Hyderabad, Telangana - 500072</div>
              </div>
            </div>

            <div className="info-row">
              <div className="info-icon"><FaPhone /></div>
              <div className="info-content">
                <div className="info-title">Phone</div>
                <div className="info-sub" style={{fontSize: 22}}>+91 7330643345</div>
              </div>
            </div>

            <div className="info-row">
              <div className="info-icon"><FaEnvelope /></div>
              <div className="info-content">
                <div className="info-title">Email</div>
                <div className="info-sub" style={{fontSize: 22}}>eliteacademy21@gmail.com</div>
              </div>
            </div>

            <div style={{ marginTop: 6 }}>
              <div className="info-title">Office Hours</div>
              <div className="hours">
                <div className="badge"><FaClock style={{ marginRight: 10 }} /> Mon - Fri: 9:30am - 5:30pm</div>
                <div className="badge">Sat: 10:00am - 2:00pm</div>
              </div>
            </div>
          </div>

          <hr style={{ margin: "22px 0", border: "none", borderTop: "1px solid #f1f1f1" }} />

          <form className="contact-form" onSubmit={handleSubmit}>
            <input
              required
              placeholder="Your name"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
            />
            <input
              required
              type="email"
              placeholder="Your email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
            />
            <textarea
              required
              rows={6}
              placeholder="How can we help?"
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
            />
            <button type="submit">Send message</button>
          </form>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
          <div className="contact-card map-embed">
            {/* Google Maps embed - replace src with your actual map if needed */}
            <iframe
              title="Elite Academy Location"
              width="100%"
              height="100%"
              frameBorder="0"
              style={{ border: 0 }}
              src="https://www.google.com/maps?q=KPHB+Colony+Kukatpally+Hyderabad&output=embed"
              allowFullScreen
            />
          </div>

          <div className="contact-card">
            <h3 style={{ marginTop: 0, fontSize: 20, color: "var(--heading)" }}>Quick links</h3>
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              <button onClick={() => go("/features")} style={{ textAlign: "left", background: "transparent", border: "1px solid #eef2ff", padding: 12, borderRadius: 8, cursor: "pointer", fontWeight:800 }}>Our Features</button>
              <button onClick={() => go("/about")} style={{ textAlign: "left", background: "transparent", border: "1px solid #eef2ff", padding: 12, borderRadius: 8, cursor: "pointer", fontWeight:800 }}>About Elite Academy</button>
              <a href="mailto:eliteacademy21@gmail.com" style={{ textDecoration: "none" }}>
                <button style={{ textAlign: "left", background: "linear-gradient(90deg,var(--brand-1),var(--brand-2))", color: "#fff", border: "none", padding: 12, borderRadius: 8, cursor: "pointer", fontWeight:900 }}>Email Us</button>
              </a>
            </div>
          </div>
        </div>
      </main>

      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} Elite Academy. All Rights Reserved.</p>
      </footer>
    </div>
  );
};

export default Contact;